import getActiveTab from './utility/get-active-tab';

const newSinceRecordsCountLabel = document.querySelector('#new_since_records_label');
const newSinceRecordsCountInput = document.querySelector('#limited-time-record-type-new');
const modifiedSinceRecordsCountLabel = document.querySelector('#modified_since_records_label');
const modifiedSinceRecordsCountInput = document.querySelector('#limited-time-record-type-modified');
const newAndModifiedSinceRecordsCountLabel = document.querySelector('#all_since_records_label');
const allSinceRecordsCountInput = document.querySelector('#limited-time-record-type-all');
const deletedSinceRecordsCountLabel = document.querySelector('#deleted_since_records_label');
const deletedSinceRecordsCountInput = document.querySelector('#limited-time-record-type-deleted');
const allRecordsCountLabel = document.querySelector('#all_records_label');
const allTimeRecordsCountInput = document.querySelector('#all-time-record-type-all');
const deletedRecordsCountLabel = document.querySelector('#deleted_records_label');
const deletedAllTimeRecordsCountInput = document.querySelector('#all-time-record-type-deleted');
const allTimeScopeInput = document.querySelector('#timespan-scope-all-time');
const allTimeScopeLabel = document.querySelector('#timespan-scope-all-time-label');
const totalRecordsCount = document.querySelector('#total-matches');
const mainForm = document.querySelector('#main-form');
const currentTab = getActiveTab(mainForm);

class RecordsCount {
	constructor(options = {}) {
		this.restApi = options.api;
		this.hasRecords = false;
	}

	hasAnyRecords() {
		return this.hasRecords;
	}

	displayTotalRecordsCount(filters) {
		return this.restApi
			.getTabResults(currentTab, mainForm)
			.then(data => {
				if (data.error === undefined) {
					this._recordsCountUiHandler(data, filters);
					this._checkHasRecords(data.sinceResults, data.allTimeResults);
					this._setTotalCount(data.sinceResults, data.allTimeResults);
				}
				return data;
			});
	}

	_enableTotalCount() {
		totalRecordsCount.classList.add('c-filter-download__total-matches--active');
	}

	disableTotalCount() {
		totalRecordsCount.innerHTML = '(no matching records)';
		if (totalRecordsCount.classList.contains('c-filter-download__total-matches--active')) {
			totalRecordsCount.classList.remove('c-filter-download__total-matches--active');
		}
	}

	errorTotalCount() {
		totalRecordsCount.innerHTML = '(right now we can\'t count how many records you selected)';
		if (totalRecordsCount.classList.contains('c-filter-download__total-matches--active')) {
			totalRecordsCount.classList.remove('c-filter-download__total-matches--active');
		}
	}

	_checkHasRecords(sinceResults, allTimeResults) {
		if (sinceResults !== undefined) {
			this.hasRecords = Boolean(sinceResults.new !== 0 ||
				sinceResults.modified !== 0 ||
				sinceResults.deleted !== 0 ||
				sinceResults.newAndModified !== 0);
		} else if (allTimeResults === undefined) {
			this.hasRecords = false;
		} else {
			this.hasRecords = (allTimeResults.all !== 0 || allTimeResults.deleted !== 0);
		}
	}

	_setTotalCount(sinceResults, allTimeResults) {
		console.log(allTimeResults);
		this._handleRecordCountUIStatus();
		if (sinceResults !== undefined) {
			if (sinceResults.new !== 0 || sinceResults.modified !== 0 ||
        sinceResults.deleted !== 0 || sinceResults.newAndModified !== 0) {
				this._displayRecordCountForType('limited_time_record_type');
			}
		} else if (allTimeResults.all !== 0 || allTimeResults.deleted !== 0) {
			if (currentTab === 'books') {
				this._displayRecordCountForType('all_time_record_type');
			} else {
				totalRecordsCount.innerHTML = '(' + allTimeScopeInput.getAttribute('data-match') + ' matching records)';
			}
		}
	}

	_handleRecordCountUIStatus() {
		if (this.hasAnyRecords()) {
			this._enableTotalCount();
		} else {
			this.disableTotalCount();
		}
	}

	_displayRecordCountForType(recordType) {
		const input = document.querySelector('input[name="' + recordType + '"]:checked');
		if (input) {
			totalRecordsCount.innerHTML = '(' + input.getAttribute('data-match') + ' matching records)';
		}
	}

	_recordsCountUiHandler(data, filterScope) {
		if (filterScope === false) {
			newSinceRecordsCountLabel.innerHTML = 'Only new (' + data.sinceResults.new + ')';
			newSinceRecordsCountInput.dataset.match = data.sinceResults.new;

			modifiedSinceRecordsCountLabel.innerHTML = 'Only modified (' + data.sinceResults.modified + ')';
			modifiedSinceRecordsCountInput.dataset.match = data.sinceResults.modified;

			newAndModifiedSinceRecordsCountLabel.innerHTML = 'New and modified (' + data.sinceResults.newAndModified + ')';
			allSinceRecordsCountInput.dataset.match = data.sinceResults.newAndModified;

			if (currentTab === 'books') {
				deletedSinceRecordsCountLabel.innerHTML = 'Only deleted (' + data.sinceResults.deleted + ')';
				deletedSinceRecordsCountInput.dataset.match = data.sinceResults.deleted;

				allRecordsCountLabel.innerHTML = 'All active records';
				allTimeRecordsCountInput.dataset.match = 0;

				deletedRecordsCountLabel.innerHTML = 'Only deleted';
				deletedAllTimeRecordsCountInput.dataset.match = 0;
			} else {
				allTimeScopeLabel.innerHTML = 'All time';
				allTimeScopeInput.dataset.match = 0;
			}
		} else {
			newSinceRecordsCountLabel.innerHTML = 'Only new';
			newSinceRecordsCountInput.dataset.match = 0;

			modifiedSinceRecordsCountLabel.innerHTML = 'Only modified';
			modifiedSinceRecordsCountInput.dataset.match = 0;

			newAndModifiedSinceRecordsCountLabel.innerHTML = 'New and modified';
			allSinceRecordsCountInput.dataset.match = 0;

			if (currentTab === 'books') {
				deletedSinceRecordsCountLabel.innerHTML = 'Only deleted';
				deletedSinceRecordsCountInput.dataset.match = 0;

				allRecordsCountLabel.innerHTML = 'All active records (' + data.allTimeResults.all + ')';
				allTimeRecordsCountInput.dataset.match = data.allTimeResults.all;

				deletedRecordsCountLabel.innerHTML = 'Only deleted (' + data.allTimeResults.deleted + ')';
				deletedAllTimeRecordsCountInput.dataset.match = data.allTimeResults.deleted;
			} else if (data.allTimeResults.all !== 0) {
				allTimeScopeLabel.innerHTML = 'All time (' + data.allTimeResults.all + ')';
				allTimeScopeInput.dataset.match = data.allTimeResults.all;
			}
		}
	}
}

export default RecordsCount;
